// import React, { useState } from 'react';
// import Layout from '../../Component/Layout/Layout';
// import '../../Styles/dashboard.css';

// const Dashboard = () => {
//   const [showAllCommissions, setShowAllCommissions] = useState(false);
//   const [showCommissionModal, setShowCommissionModal] = useState(false);
//   const [copySuccess, setCopySuccess] = useState(false);

//   const stats = [
//     {
//       title: 'Total Earnings',
//       value: '₹25,430',
//       change: '+12%',
//       trend: 'up',
//       icon: '💰',
//       color: 'success'
//     },
//     {
//       title: 'Pending Commissions',
//       value: '₹8,250',
//       change: '+5%',
//       trend: 'up',
//       icon: '⏳',
//       color: 'warning'
//     },
//     {
//       title: 'Total Referrals',
//       value: '156',
//       change: '+8%',
//       trend: 'up',
//       icon: '👥',
//       color: 'info'
//     },
//     {
//       title: 'Commission Rate',
//       value: '15%',
//       change: 'Fixed',
//       trend: 'neutral',
//       icon: '📊',
//       color: 'primary'
//     }
//   ];

//   // Extended commissions data with more entries
//   const allCommissions = [
//     { id: 1, bookingId: 'BK001', amount: '₹1,250', date: '2024-01-15', status: 'Paid' },
//     { id: 2, bookingId: 'BK002', amount: '₹850', date: '2024-01-14', status: 'Pending' },
//     { id: 3, bookingId: 'BK003', amount: '₹2,100', date: '2024-01-13', status: 'Paid' },
//     { id: 4, bookingId: 'BK004', amount: '₹750', date: '2024-01-12', status: 'Paid' },
//     { id: 5, bookingId: 'BK005', amount: '₹1,500', date: '2024-01-11', status: 'Paid' },
//     { id: 6, bookingId: 'BK006', amount: '₹950', date: '2024-01-10', status: 'Pending' },
//     { id: 7, bookingId: 'BK007', amount: '₹1,800', date: '2024-01-09', status: 'Paid' },
//     { id: 8, bookingId: 'BK008', amount: '₹650', date: '2024-01-08', status: 'Paid' },
//     { id: 9, bookingId: 'BK009', amount: '₹2,300', date: '2024-01-07', status: 'Pending' },
//     { id: 10, bookingId: 'BK010', amount: '₹1,100', date: '2024-01-06', status: 'Paid' },
//     { id: 11, bookingId: 'BK011', amount: '₹890', date: '2024-01-05', status: 'Paid' },
//     { id: 12, bookingId: 'BK012', amount: '₹1,750', date: '2024-01-04', status: 'Paid' }
//   ];

//   // Show only first 5 commissions in the table, show all in modal
//   const displayedCommissions = showAllCommissions ? allCommissions : allCommissions.slice(0, 5);

//   const handleCopyCode = () => {
//     navigator.clipboard.writeText('BUSINFLUENCE25')
//       .then(() => {
//         setCopySuccess(true);
//         setTimeout(() => setCopySuccess(false), 2000);
//       })
//       .catch(err => {
//         console.error('Failed to copy: ', err);
//       });
//   };

//   const handleViewAll = () => {
//     setShowCommissionModal(true);
//   };

//   const closeModal = () => {
//     setShowCommissionModal(false);
//   };

//   return (
//     <Layout>
//       <div className="dashboard">
//         <div className="dashboard-header">
//           <h1 className="dashboard-title">Dashboard</h1>
//           <p className="dashboard-subtitle">Welcome back! Here's your performance overview.</p>
//         </div>

//         {/* Stats Grid */}
//         <div className="stats-grid">
//           {stats.map((stat, index) => (
//             <div key={index} className={`stat-card stat-card--${stat.color}`}>
//               <div className="stat-icon">
//                 <span>{stat.icon}</span>
//               </div>
//               <div className="stat-content">
//                 <h3 className="stat-value">{stat.value}</h3>
//                 <p className="stat-title">{stat.title}</p>
//                 <div className={`stat-change stat-change--${stat.trend}`}>
//                   <span>{stat.change}</span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="dashboard-content">
//           {/* Recent Commissions */}
//           <div className="content-section">
//             <div className="section-header">
//               <h2 className="section-title">Recent Commissions</h2>
//               <button className="view-all-btn" onClick={handleViewAll}>
//                 View All
//               </button>
//             </div>
//             <div className="commissions-table">
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Booking ID</th>
//                     <th>Amount</th>
//                     <th>Date</th>
//                     <th>Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {displayedCommissions.map((commission) => (
//                     <tr key={commission.id}>
//                       <td>{commission.bookingId}</td>
//                       <td className="amount">{commission.amount}</td>
//                       <td>{commission.date}</td>
//                       <td>
//                         <span className={`status-badge status-${commission.status.toLowerCase()}`}>
//                           {commission.status}
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//               {!showAllCommissions && allCommissions.length > 5 && (
//                 <div className="table-footer">
//                   <p>Showing 5 of {allCommissions.length} commissions</p>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Quick Stats */}
//           <div className="content-grid">
//             <div className="content-card">
//               <h3 className="card-title">Performance Overview</h3>
//               <div className="performance-stats">
//                 <div className="performance-item">
//                   <span className="performance-label">This Month</span>
//                   <span className="performance-value">₹12,450</span>
//                 </div>
//                 <div className="performance-item">
//                   <span className="performance-label">Last Month</span>
//                   <span className="performance-value">₹10,230</span>
//                 </div>
//                 <div className="performance-item">
//                   <span className="performance-label">Conversion Rate</span>
//                   <span className="performance-value">8.5%</span>
//                 </div>
//               </div>
//             </div>

//             <div className="content-card">
//               <h3 className="card-title">Your Referral Code</h3>
//               <div className="referral-section">
//                 <div className="referral-code">
//                   <code>BUSINFLUENCE25</code>
//                 </div>
//                 <p className="referral-note">
//                   Share this code with your audience to earn commissions on their bookings.
//                 </p>
//                 <button 
//                   className={`copy-btn ${copySuccess ? 'copied' : ''}`}
//                   onClick={handleCopyCode}
//                 >
//                   {copySuccess ? '✓ Copied!' : 'Copy Code'}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Commission Details Modal */}
//         {showCommissionModal && (
//           <div className="modal-overlay" onClick={closeModal}>
//             <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//               <div className="modal-header">
//                 <h3>All Commissions</h3>
//                 <button className="modal-close" onClick={closeModal}>×</button>
//               </div>
//               <div className="modal-body">
//                 <div className="commissions-table">
//                   <table>
//                     <thead>
//                       <tr>
//                         <th>Booking ID</th>
//                         <th>Amount</th>
//                         <th>Date</th>
//                         <th>Status</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {allCommissions.map((commission) => (
//                         <tr key={commission.id}>
//                           <td>{commission.bookingId}</td>
//                           <td className="amount">{commission.amount}</td>
//                           <td>{commission.date}</td>
//                           <td>
//                             <span className={`status-badge status-${commission.status.toLowerCase()}`}>
//                               {commission.status}
//                             </span>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button className="close-btn" onClick={closeModal}>
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </Layout>
//   );
// };

// export default Dashboard;

// Component/Dashboard/Dashboard.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../Component/Layout/Layout';
import '../../Styles/dashboard.css';
import { 
  getInfluencerDashboard,
  getInfluencerCommissions,
  influencerLogout
} from '../../Services/Operations/ProductAPI';
import { formatIndianCurrency } from '../../Utils/formatters';
import { useSelector } from 'react-redux';

const Dashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [dashboardData, setDashboardData] = useState(null);
  const [stats, setStats] = useState([]);
  const [recentCommissions, setRecentCommissions] = useState([]);
  const [showAllCommissions, setShowAllCommissions] = useState(false);
  const [showCommissionModal, setShowCommissionModal] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [referralCode, setReferralCode] = useState('');
    const { token, loginData } = useSelector(state => state.influencer);

  useEffect(() => {
    if (!token) {
      navigate('/login');
      return;
    }
    fetchDashboardData(token);
  }, [navigate]);

  const fetchDashboardData = async (token) => {
    try {
      setLoading(true);

      const dashboardResponse = await getInfluencerDashboard(token);
      console.log("dashboardResponse : ",dashboardResponse);
      
      if (dashboardResponse && dashboardResponse.stats) {
        setDashboardData(dashboardResponse);

        const transformedStats = [
          {
            title: 'Total Earnings',
            value: formatIndianCurrency(dashboardResponse.stats.totalEarnings),
            change: '+12%',
            trend: 'up',
            icon: '💰',
            color: 'success',
            rawValue: dashboardResponse.stats.totalEarnings
          },
          {
            title: 'Pending Commissions',
            value: formatIndianCurrency(dashboardResponse.stats.pendingEarnings),
            change: '+5%',
            trend: 'up',
            icon: '⏳',
            color: 'warning',
            rawValue: dashboardResponse.stats.pendingEarnings
          },
          {
            title: 'Total Referrals',
            value: dashboardResponse.stats.totalReferrals.toString(),
            change: '+8%',
            trend: 'up',
            icon: '👥',
            color: 'info',
            rawValue: dashboardResponse.stats.totalReferrals
          },
          {
            title: 'Commission Rate',
            value: `${dashboardResponse.stats.commissionRate || 15}%`,
            change: 'Fixed',
            trend: 'neutral',
            icon: '📊',
            color: 'primary',
            rawValue: dashboardResponse.stats.commissionRate || 15
          }
        ];
        
        setStats(transformedStats);
        setRecentCommissions(dashboardResponse.recentCommissions || []);
        
        // Fetch profile for referral code
        const profileData = JSON.parse(localStorage.getItem('influencerProfile') || '{}');
        setReferralCode(dashboardResponse.referralCode);
      }
      
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      
      // If token is invalid, redirect to login
      if (error.response?.status === 401) {
        localStorage.removeItem('influencerToken');
        localStorage.removeItem('influencerProfile');
        navigate('/influencer/login');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCopyCode = () => {
    navigator.clipboard.writeText(referralCode)
      .then(() => {
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  const handleViewAll = () => {
    setShowCommissionModal(true);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const getCommissionStatus = (status) => {
    const statusMap = {
      'pending': { label: 'Pending', className: 'pending' },
      'paid': { label: 'Paid', className: 'paid' },
      'failed': { label: 'Failed', className: 'failed' }
    };
    
    return statusMap[status] || { label: status, className: 'pending' };
  };

  const handleCommissionClick = (commission) => {
    // Navigate to commission details or show modal
    console.log('Commission clicked:', commission);
    // You can implement detailed view here
  };

  const calculatePerformance = () => {
    if (!dashboardData?.monthlyEarnings || dashboardData.monthlyEarnings.length === 0) {
      return {
        thisMonth: 0,
        lastMonth: 0,
        conversionRate: '0%'
      };
    }

    const monthlyData = dashboardData.monthlyEarnings;
    const currentMonth = new Date().getMonth() + 1;
    const currentYear = new Date().getFullYear();

    const thisMonthEarnings = monthlyData
      .filter(item => item._id.month === currentMonth && item._id.year === currentYear)
      .reduce((sum, item) => sum + item.total, 0);

    const lastMonthEarnings = monthlyData
      .filter(item => item._id.month === (currentMonth - 1 || 12) && item._id.year === (currentMonth === 1 ? currentYear - 1 : currentYear))
      .reduce((sum, item) => sum + item.total, 0);

    // Calculate conversion rate (simple example)
    const totalBookings = dashboardData.stats?.totalReferrals || 0;
    const successfulBookings = recentCommissions.filter(c => c.status === 'paid').length;
    const conversionRate = totalBookings > 0 ? ((successfulBookings / totalBookings) * 100).toFixed(1) : 0;

    return {
      thisMonth: thisMonthEarnings,
      lastMonth: lastMonthEarnings,
      conversionRate: `${conversionRate}%`
    };
  };

  const performanceData = calculatePerformance();

  if (loading) {
    return (
      <Layout>
        <div className="dashboard loading">
          <div className="loading-spinner"></div>
          <p>Loading dashboard data...</p>
        </div>
      </Layout>
    );
  }

  // Display only first 5 commissions in the table
  const displayedCommissions = showAllCommissions ? 
    recentCommissions : 
    recentCommissions.slice(0, 5);

  return (
    <Layout>
      <div className="dashboard">
        <div className="dashboard-header">
          <h1 className="dashboard-title">Dashboard</h1>
          <p className="dashboard-subtitle">
            Welcome back! Here's your performance overview.
          </p>
         
        </div>

        {/* Stats Grid */}
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className={`stat-card stat-card--${stat.color}`}>
              <div className="stat-icon">
                <span>{stat.icon}</span>
              </div>
              <div className="stat-content">
                <h3 className="stat-value">{stat.value}</h3>
                <p className="stat-title">{stat.title}</p>
                <div className={`stat-change stat-change--${stat.trend}`}>
                  <span>{stat.change}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="dashboard-content">
          {/* Recent Commissions */}
          <div className="content-section">
            <div className="section-header">
              <h2 className="section-title">Recent Commissions</h2>
              {/* {recentCommissions.length > 5 && (
                // <button className="view-all-btn" onClick={handleViewAll}>
                //   View All ({recentCommissions.length})
                // </button>
              )} */}
            </div>
            
            {recentCommissions.length === 0 ? (
              <div className="empty-state">
                <p>No commissions yet. Start sharing your referral code!</p>
              </div>
            ) : (
              <div className="commissions-table">
                <table>
                  <thead>
                    <tr>
                      <th>Booking ID</th>
                      <th>Route</th>
                      <th>Amount</th>
                      <th>Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedCommissions.map((commission) => {
                      const statusInfo = getCommissionStatus(commission.status);
                      return (
                        <tr 
                          key={commission._id} 
                          className="commission-row"
                          onClick={() => handleCommissionClick(commission)}
                        >
                          <td>{commission.booking?.pnr || 'N/A'}</td>
                          <td className="route-info">
                            {commission.booking?.routeId?.from} → {commission.booking?.routeId?.to}
                          </td>
                          <td className="amount">
                            {formatIndianCurrency(commission.amount)}
                          </td>
                          <td>{formatDate(commission.createdAt)}</td>
                          <td>
                            <span className={`status-badge status-${statusInfo.className}`}>
                              {statusInfo.label}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                
                {!showAllCommissions && recentCommissions.length > 5 && (
                  <div className="table-footer">
                    <p>Showing 5 of {recentCommissions.length} commissions</p>
                   
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Quick Stats & Referral Section */}
          <div className="content-grid">
            <div className="content-card">
              <h3 className="card-title">Performance Overview</h3>
              <div className="performance-stats">
                <div className="performance-item">
                  <span className="performance-label">This Month</span>
                  <span className="performance-value">
                    {formatIndianCurrency(performanceData.thisMonth)}
                  </span>
                </div>
                <div className="performance-item">
                  <span className="performance-label">Last Month</span>
                  <span className="performance-value">
                    {formatIndianCurrency(performanceData.lastMonth)}
                  </span>
                </div>
                <div className="performance-item">
                  <span className="performance-label">Conversion Rate</span>
                  <span className="performance-value">{performanceData.conversionRate}</span>
                </div>
              </div>
              
              {/* Monthly Earnings Chart (Simple visualization) */}
              {dashboardData?.monthlyEarnings && dashboardData.monthlyEarnings.length > 0 && (
                <div className="monthly-chart">
                  <h4>Monthly Earnings Trend</h4>
                  <div className="chart-bars">
                    {dashboardData.monthlyEarnings.slice(-6).map((item, index) => (
                      <div key={index} className="chart-bar-container">
                        <div className="chart-bar-label">
                          {`${item._id.month}/${item._id.year.toString().slice(-2)}`}
                        </div>
                        <div className="chart-bar">
                          <div 
                            className="chart-bar-fill"
                            style={{
                              height: `${(item.total / Math.max(...dashboardData.monthlyEarnings.map(m => m.total))) * 100}%`
                            }}
                          >
                            <span className="chart-bar-value">
                              {formatIndianCurrency(item.total)}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="content-card">
              <h3 className="card-title">Your Referral Code</h3>
              <div className="referral-section">
                <div className="referral-code">
                  <code>{dashboardData?.referralCode}</code>
                </div>
                {/* <p className="referral-note">
                  Share this code with your audience to earn commissions on their bookings.
                </p> */}
                <button 
                  className={`copy-btn ${copySuccess ? 'copied' : ''}`}
                  onClick={handleCopyCode}
                >
                  {copySuccess ? '✓ Copied!' : 'Copy Code'}
                </button>
                
               
              </div>
            </div>
          </div>
        </div>

       
      </div>
    </Layout>
  );
};

export default Dashboard;